import { AbstractPmsApiService } from "./abstract.service";
/**
 * @class PropertyAmenityPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Property>}
 */
export class PropertyAmenityPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/amenity';
    }
    
    /**
     * @param {Object} attributes
     * @return {Object}
     */
    newModel(attributes) {
        
        return attributes;
    }
    
    /**
     * @param {Property} property
     * @returns {Promise.<PaginationCollection<Property>>}
     */
    get (property) {
        
        const url = this.url({propertyId: property.id});
        return this.http
                   .get(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Property} property
     * @param {Array} selectedAmenities
     * @param {Array} customAmenities
     * @returns {Promise.<Property>}
     */
    save (property, selectedAmenities, customAmenities) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
            .post(url, {selectedAmenities: selectedAmenities, customAmenities: customAmenities}, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/property-amenity.service.js